import logo from '~/images/logo-with-text.svg';
import { Link } from '~/remix';

export default function MainFooter() {
  return (
    <footer className="mx-8 my-8 border-t border-accent-dark py-8 sm:mx-16">
      <div className="flex items-center justify-between">
        <div className="hidden sm:block">
          <div className="flex items-center justify-center">
            <h1 className="text-lg uppercase tracking-widest sm:text-2xl">
              <Link to="/">
                <img
                  src={logo}
                  className="mr-3 h-[110px] w-[110px]"
                  alt="Sunset Messages"
                />
              </Link>
            </h1>
          </div>
          <div className="mt-1 text-center text-sm text-gray-600">
            &copy; {new Date(Date.now()).getFullYear()} Sunset Messages.
          </div>
          <div className="text-center text-sm text-gray-600">
            All rights reserved. Norfolk, VA
          </div>
        </div>
        <div className="flex w-full justify-around leading-7 sm:w-auto sm:gap-x-12 lg:gap-x-24 lg:text-lg lg:leading-7">
          <div className="flex flex-col items-center">
            <ul>
              <li>
                <FooterLink to="/dedicate">Dedication</FooterLink>
              </li>
              <li>
                <FooterLink to="/pricing">Pricing</FooterLink>
              </li>
              <li>
                <FooterLink to="/help">What to say</FooterLink>
              </li>
              <li>
                <FooterLink to="/faq">FAQ</FooterLink>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center">
            <ul>
              <li>
                <FooterLink to="/privacy">Privacy</FooterLink>
              </li>
              <li>
                <FooterLink to="/terms">Terms</FooterLink>
              </li>
              <li>
                <FooterLink to="/about">About</FooterLink>
              </li>
              <li>
                <FooterLink to="/contact">Contact</FooterLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-4 flex flex-col items-center sm:hidden">
        <div className="flex items-center">
          <img
            src={logo}
            className="mr-3 h-[20px] w-[25px] sm:h-[30px] sm:w-[38px]"
            alt="Sunset Messages"
          />
          <h1 className="text-lg uppercase tracking-widest sm:text-2xl">
            <Link to="/">Sunset Messages</Link>
          </h1>
        </div>
        <div className="mt-2 text-center text-sm text-gray-600">
          &copy; {new Date(Date.now()).getFullYear()} Sunset Messages.
          <br />
          All rights reserved. Norfolk, VA
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ to, children }: { to: string; children: any }) {
  return (
    <Link
      to={to}
      className="text-gray-500 hover:text-accent-medium hover:underline"
    >
      {children}
    </Link>
  );
}
